import axiosInstance from "../../../helpers/api";

export const listAllMainStudentExams = (search = null) => {
  const params = search ? { search } : {};
  return axiosInstance.get("/admin/student_exams/main_exam", { params });
};

export const redoExam = (studentExamId) => {
  return axiosInstance.post("/admin/student_exams/redo_exam", {
    student_exam_id: studentExamId,
  });
};

export const getStudentExamsByExamId = (examId) => {
  return axiosInstance.get(`/admin/student_exams/get_exams/${examId}`);
};

export const getCorrectionQuestions = (studentExamId) => {
  return axiosInstance.get(`/admin/student_exams/get_questions/${studentExamId}`);
};

export const correctStudentExam = (body) => {
  return axiosInstance.post("/admin/student_exams/correct_exam", body);
};

export const getCorrectedQuestions = (studentExamId) => {
  return axiosInstance.get(`/admin/student_exams/get_corrected_questions/${studentExamId}`);
};

